import { useEffect, useState } from 'react'
import { useMsal } from '@azure/msal-react'
import { MPMLayout } from 'components/layout'
import { useTranslation } from 'react-i18next'
import { loadReport } from './helpers'

export default function EmbeddedReport() {
    const { instance, accounts } = useMsal()
    const { t } = useTranslation()

    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        loadReport({ accounts, instance, setError, t }).catch((err: Error) => {
            setError((err as Error).message ?? 'Unknown error')
        })
    }, [accounts, instance, t])

    return (
        <MPMLayout>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <div className="hc8-mv-4x">
                TODO: implement in MYPM-3321 and properly handle/show errors
            </div>
            <div>{error}</div>
        </MPMLayout>
    )
}
